// src/app/interceptors/auth.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable }                                 from 'rxjs';
import { switchMap, take }                            from 'rxjs/operators';
import { Auth, idToken }                              from '@angular/fire/auth';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: Auth) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // idToken(this.auth) emits the current JWT (or null) whenever it changes
    return idToken(this.auth).pipe(
      take(1),  // just grab the latest token once
      switchMap(token => {
        // If there's no token (not signed in), just pass through
        if (!token) {
          return next.handle(req);
        }
        // Otherwise clone the request and add the header
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
        return next.handle(authReq);
      })
    );
  }
}
